module.exports = __webpack_public_path__ + "img/20200613_093637.22713198.jpg";